import React from 'react';
import { FaCrown, FaEnvelope, FaLock, FaPhoneAlt } from 'react-icons/fa';
import CloseButton from './CloseButton';

const DEFAULT_SUPPORT_EMAIL = 'support@shiftsmart.com.au';
const DEFAULT_SUPPORT_PHONE = '+61 2 8000 0000';

const getPhoneHref = (phoneNumber) => {
  const dialableNumber = phoneNumber.toString().replace(/[^\d+]/g, '');
  return dialableNumber ? `tel:${dialableNumber}` : '';
};

const PremiumFeatureModal = ({
  isOpen,
  onClose,
  featureName = 'This feature',
  endpoint = '',
  supportEmail = DEFAULT_SUPPORT_EMAIL,
  supportPhone = DEFAULT_SUPPORT_PHONE,
}) => {
  if (!isOpen) return null;

  const hasSupportEmail = Boolean(supportEmail?.trim());
  const hasSupportPhone = Boolean(supportPhone?.trim());
  const supportPhoneHref = hasSupportPhone ? getPhoneHref(supportPhone) : '';

  return (
    <div className="fixed inset-0 z-[1200] flex items-center justify-center bg-slate-900/70 px-4">
      <div className="w-full max-w-lg rounded-2xl border border-cyan-400/30 bg-gradient-to-br from-[#0b1220] to-[#0f172a] p-5 text-white shadow-2xl sm:p-6">
        <div className="mb-5 flex items-start justify-between">
          <div className="inline-flex items-center gap-2 rounded-full border border-amber-400/30 bg-amber-500/15 px-3 py-1 text-xs font-semibold uppercase tracking-wide text-amber-200">
            <FaCrown className="text-[11px]" />
            Premium Access
          </div>
          <CloseButton
            onClick={onClose}
            label="Close premium access modal"
          />
        </div>

        <div className="mb-4 flex items-start gap-3">
          <div className="flex h-12 w-12 shrink-0 items-center justify-center rounded-xl border border-cyan-400/30 bg-cyan-400/15 text-cyan-300">
            <FaLock />
          </div>
          <div className="min-w-0">
            <h2 className="text-xl font-bold leading-tight">{featureName} is not included in your package</h2>
            <p className="mt-1 text-sm text-slate-300">Upgrade your tenant package to unlock this feature.</p>
          </div>
        </div>

        <div className="mt-5 rounded-xl border border-emerald-400/20 bg-emerald-400/10 p-4 text-sm text-emerald-50">
          <p className="font-semibold text-emerald-100">Need access?</p>
          <p className="mt-1 leading-5 text-emerald-100/90">
            Contact your administrator to enable this module for your tenant, or reach ShiftSmart support for help.
          </p>

          {(hasSupportEmail || supportPhoneHref) && (
            <div className="mt-3 grid gap-2 sm:grid-cols-2">
              {hasSupportEmail && (
                <a
                  href={`mailto:${supportEmail.trim()}?subject=${encodeURIComponent(`Enable ${featureName}`)}`}
                  className="flex min-h-[2.5rem] items-center justify-center gap-2 rounded-lg border border-emerald-300/25 bg-slate-950/25 px-3 text-xs font-semibold text-emerald-50 transition hover:border-emerald-200/60 hover:bg-emerald-300/10 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-emerald-200/70"
                >
                  <FaEnvelope aria-hidden="true" />
                  <span className="break-all">{supportEmail}</span>
                </a>
              )}
              {supportPhoneHref && (
                <a
                  href={supportPhoneHref}
                  className="flex min-h-[2.5rem] items-center justify-center gap-2 rounded-lg border border-emerald-300/25 bg-slate-950/25 px-3 text-xs font-semibold text-emerald-50 transition hover:border-emerald-200/60 hover:bg-emerald-300/10 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-emerald-200/70"
                >
                  <FaPhoneAlt aria-hidden="true" />
                  <span>{supportPhone}</span>
                </a>
              )}
            </div>
          )}
        </div>

      </div>
    </div>
  );
};

export default PremiumFeatureModal;
